import { store } from "../state/redux";
import { modifyonelead } from "./actions_lead";


import { axios_contrats_createcontrat } from "../axios/axios_contrats";


export const jsonstatutscontrats ={'projet':'Projet','encours':'En cours','impaye_1mois':'Impayé un mois',
                                    'impaye_2mois':'Impayé deux mois','impaye_3mois':'Impayé trois mois',
                                    'resiliecmugroupe':'Résilié CMU / Contrat groupe','resilieecheanceria':'Résilié Echeance / RIA',
                                    'radiation':'Résilié Radiation','retractation':'Résilié Rétractation','resilieautre':'Résilié Autre',
                                    'attentesignature':'Attente Signature','annule':'Annulé'}


export const enregistrerformuleinterne =async (contrat)=>{ 
  const lead = store.getState().lead.leadactu; 
  const req = await axios_contrats_createcontrat(contrat) ;
  modifyonelead({'date_effet':lead.date_effet ,'sign_formule':2 ,'sign_fic':0,'sign_bulletin':0,'id_contrat':req.data.id_contrat });
  return req.data.id_contrat
}


export const enregistrerformulelibre = async (contrat)=>{
    const req = await axios_contrats_createcontrat(contrat);
    modifyonelead({'sign_formule':2,'sign_fic':0,'sign_bulletin':0, 'id_contrat':req.data.id_contrat });
    return req.data.id_contrat
}



